import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "./SvgIcon";
import { setAppliedMode } from "../utils/theme-helpers";
import submit from "submit-form";
import { useRillContext } from "../rill/RillReact/share/base";

const ThemeToggler = () => {
  const { t } = useTranslation("common");
  const { locals } = useRillContext();

  const [theme, setTheme] = useState(locals.activeUser?.webAppTheme || "");
  const toggleTheme = () => {
    const themeToSet = theme === "dark" ? "light" : "dark";
    setTheme(themeToSet);
    setAppliedMode(themeToSet);

    const isFromChat = locals.pathname.includes("/coaching-portal/chat");

    submit("/actions/theme", {
      method: "POST",
      body: {
        webAppTheme: themeToSet,
        isFromChat,
      },
    });
  };

  return (
    <button className={theme} onClick={toggleTheme}>
      <>
        <div aria-current={theme === "light" ? true : undefined}>
          <SvgIcon
            src={`/img/new-icons/light-theme-${
              theme === "light" ? "enabled" : "disabled"
            }.svg`}
          />
          <span>{t("theme.light")}</span>
        </div>
        <SvgIcon
          aria-current
          src={`/img/new-icons/${
            theme === "dark" ? "dark" : "light"
          }-theme-enabled.svg`}
          noFilterOnLight={true}
        />
        <div aria-current={theme === "dark" ? true : undefined}>
          <SvgIcon
            src={`/img/new-icons/dark-theme-${
              theme === "dark" ? "enabled" : "disabled"
            }.svg`}
          />
          <span>{t("theme.dark")}</span>
        </div>
      </>

      {/* {expanded ? (
        <>
          <div aria-current={theme === "light" ? true : undefined}>
            <SvgIcon
              src={`/img/new-icons/light-theme-${
                theme === "light" ? "enabled" : "disabled"
              }.svg`}
            />
            <span>{t("theme.light")}</span>
          </div>
          <div aria-current={theme === "dark" ? true : undefined}>
            <SvgIcon
              src={`/img/new-icons/dark-theme-${
                theme === "dark" ? "enabled" : "disabled"
              }.svg`}
            />
            <span>{t("theme.dark")}</span>
          </div>
        </>
      ) : (
        <SvgIcon
          aria-current
          src={`/img/new-icons/${
            theme === "dark" ? "dark" : "light"
          }-theme-enabled.svg`}
          noFilterOnLight={theme === "light"}
        />
      )} */}
    </button>
  );
};

export default ThemeToggler;
